import * as React from 'react';
import type { SVGIconProps } from './Icon.types';

const GridIcon = React.forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', filled, ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        ref={forwardedRef}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <title>{props.title}</title>
        <path
          clipRule="evenodd"
          d="M1.5 6H22.5V7.5H1.5V6ZM1.5 11.25H22.5V12.75H1.5V11.25ZM1.5 16.5H22.5V18H1.5V16.5ZM6 1.5H7.5V22.5H6V1.5ZM11.25 1.5H12.75V22.5H11.25V1.5ZM16.5 1.5H18V22.5H16.5V1.5ZM6.75 4.95C7.74411 4.95 8.55 5.75589 8.55 6.75C8.55 7.74411 7.74411 8.55 6.75 8.55C5.75589 8.55 4.95 7.74411 4.95 6.75C4.95 5.75589 5.75589 4.95 6.75 4.95ZM12 4.95C12.9941 4.95 13.8 5.75589 13.8 6.75C13.8 7.74411 12.9941 8.55 12 8.55C11.0059 8.55 10.2 7.74411 10.2 6.75C10.2 5.75589 11.0059 4.95 12 4.95ZM17.25 4.95C18.2441 4.95 19.05 5.75589 19.05 6.75C19.05 7.74411 18.2441 8.55 17.25 8.55C16.2559 8.55 15.45 7.74411 15.45 6.75C15.45 5.75589 16.2559 4.95 17.25 4.95ZM6.75 10.2C7.74411 10.2 8.55 11.0059 8.55 12C8.55 12.9941 7.74411 13.8 6.75 13.8C5.75589 13.8 4.95 12.9941 4.95 12C4.95 11.0059 5.75589 10.2 6.75 10.2ZM12 10.2C12.9941 10.2 13.8 11.0059 13.8 12C13.8 12.9941 12.9941 13.8 12 13.8C11.0059 13.8 10.2 12.9941 10.2 12C10.2 11.0059 11.0059 10.2 12 10.2ZM17.25 10.2C18.2441 10.2 19.05 11.0059 19.05 12C19.05 12.9941 18.2441 13.8 17.25 13.8C16.2559 13.8 15.45 12.9941 15.45 12C15.45 11.0059 16.2559 10.2 17.25 10.2ZM6.75 15.45C7.74411 15.45 8.55 16.2559 8.55 17.25C8.55 18.2441 7.74411 19.05 6.75 19.05C5.75589 19.05 4.95 18.2441 4.95 17.25C4.95 16.2559 5.75589 15.45 6.75 15.45ZM12 15.45C12.9941 15.45 13.8 16.2559 13.8 17.25C13.8 18.2441 12.9941 19.05 12 19.05C11.0059 19.05 10.2 18.2441 10.2 17.25C10.2 16.2559 11.0059 15.45 12 15.45ZM17.25 15.45C18.2441 15.45 19.05 16.2559 19.05 17.25C19.05 18.2441 18.2441 19.05 17.25 19.05C16.2559 19.05 15.45 18.2441 15.45 17.25C15.45 16.2559 16.2559 15.45 17.25 15.45Z"
          fill={color}
          fillRule="evenodd"
        />
      </svg>
    );
  },
);

export default GridIcon;
